import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import HeaderFilter from './headerFilter';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'column': '',
      'direction': 'ascending',
    };
  }

  handleSort(key) {
    if (key !== this.state.column) {
      this.setState({'column': key, 'direction': 'ascending'});
      this.props.sortSuggestedOrderElements(key, 'ascending');
      return;
    }

    const newDirection = this.state.direction === 'ascending' ? 'descending' : 'ascending';
    this.setState({'direction': newDirection});
    this.props.sortSuggestedOrderElements(key, newDirection);
  }

  render() {
    const {column, direction} = this.state;

    return (
      <Table.Row>
        <Table.HeaderCell>Disp.</Table.HeaderCell>
        <HeaderFilter name='partCodeFilter' label='Código' maxLength='20' size='medium' />
        <HeaderFilter name='iccFilter' label='ICC' />
        <HeaderFilter name='sccFilter' label='SCC' />
        <Table.HeaderCell>MAD</Table.HeaderCell>
        <Table.HeaderCell>BO</Table.HeaderCell>
        <Table.HeaderCell>OH</Table.HeaderCell>
        <Table.HeaderCell>OO</Table.HeaderCell>
        <Table.HeaderCell>FACT</Table.HeaderCell>
        <HeaderFilter name='obsFilter' label='OBS' />
        <Table.HeaderCell>SOQ Venta</Table.HeaderCell>
        <Table.HeaderCell>SOQ Pedido</Table.HeaderCell>
        <Table.HeaderCell>Pedido</Table.HeaderCell>
        <Table.HeaderCell>FOB</Table.HeaderCell>
        <Table.HeaderCell
          sorted={column === 'totalFob' ? direction : null}
          onClick={this.handleSort.bind(this, 'totalFob')}
        >FOB Total</Table.HeaderCell>
        <Table.HeaderCell>Acción</Table.HeaderCell>
      </Table.Row>
    );
  }
}

const {
  sortSuggestedOrderElements,
} = Actions;

export default connect(null, {
  sortSuggestedOrderElements,
})(Filters);
